export default __webpack_public_path__ + "static/media/checkmark.5b778c97.svg";